/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cashFrontendServiceGetReceipt} from '../api'

export const useMutationCashFrontendServiceGetReceipt = createReactQueryMutationHook('cashFrontendServiceGetReceipt', cashFrontendServiceGetReceipt)
